import {
    BaseLayer
} from "esdm-map";
import { IBaseLayer } from "esdm-map/dist/baselayers/interfaces/IBaseLayer";

import TileLayer from 'ol/layer/Tile';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';


export class Buckinghamshire_BaseLayers{

    public GetBuckinghamshireOS(): IBaseLayer {

        let lyr = new TileLayer({
            visible: true,
            source: new WMTS({                
                url: "/api/ogcservice/BuckinghamshireOS",
                layer: 'Bucks_Basemapping',
                matrixSet: 'default028mm',
                format: 'image/png',
                projection: 'EPSG:27700',
                tileGrid: new WMTSTileGrid({
                    origin: [-5220400, 4470200],
                    resolutions: [264.58386250102507, 132.29193125051253, 66.14596562525627, 33.07298281262813, 16.933367200065604, 8.466683600032802, 4.233341800016401, 2.1166709000082005, 1.0583354500041002, 0.5291677250020501, 0.26458386250102506],
                    matrixIds: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]
                }),
                style: 'default',
                wrapX: false,
                attributions: `OS mapping: © Crown copyright OS 0100062456. You are granted a non-exclusive, royalty free, revocable licence solely to view the Licensed Data for non-commercial purposes for the period during which Buckinghamshire Council makes it available. You are not permitted to copy, sub-license, distribute, sell or otherwise make available the Licensed Data to third parties in any form. Third party rights to enforce the terms of this licence shall be reserved to OS.`
            })
        });
        return new BaseLayer("BucksCustom", "Ordnance Survey", lyr);
    }

}